<template>
  <div>
    <div id="modal" v-if="showModal" class="rounded">
      <div class="p-2">
        <div class="row align-items-stratch">
          <div class="col-8 my-3">
            <label for="">Catégorie</label>
            <select class="form-select" v-model="item.section_reference">
              <option
                v-for="(section, index) in sections"
                :key="index"
                :value="section.reference"
              >
                {{ section.fullName }}
              </option>
            </select>
          </div>

          <div class="col-4 my-3">
            <label for=""> Code </label>
            <input type="text" v-model="item.code" class="form-control" />
          </div>

          <div class="col-12 my-3">
            <label for="">Désignation</label>
            <input
              type="text"
              list="_items"
              v-model="item.fullName"
              class="form-control"
            />
            <datalist id="_items">
              <option
                v-for="(_item, index) in items"
                :key="index"
                :value="_item.fullName"
              >
                {{ _item.fullName }}
              </option>
            </datalist>
          </div>
        </div>

        <div class="row">
          <div class="col my-3">
            <label for=""> Prix TTC</label>
            <input type="text" v-model="item.priceTTC" class="form-control" />
          </div>

          <div class="col my-3">
            <label for="">Unité </label>
            <select class="form-select" v-model="item.measuring">
              <option value="KG">KG</option>
              <option value="U">Unité</option>
              <option value="L">Litre</option>
              <option value="M">Mètre</option>
            </select>
          </div>

          <div class="col my-3">
            <label for=""> TVA </label>
            <select class="form-select" v-model="item.tva">
              <option value="0">0 %</option>
              <option value="20" :selected="true">20 %</option>
              <option value="15">15 %</option>
              <option value="10">10 %</option>
              <option value="7">7 %</option>
              <option value="5">5 %</option>
              <option value="2.5">2.5 %</option>
            </select>
          </div>

          <div class="col-12 my-3">
            <label for="">Description</label>
            <textarea
              v-model="item.description"
              class="form-control"
            ></textarea>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col">
            <button class="btn btn-secondary" @click="showModal = !showModal">
              <i class="bi bi-check-square-fill"></i> Fermer
            </button>
          </div>

          <div class="col-auto">
            <button class="btn btn-primary" @click="saveNewCatalogItem(item)">
              <i class="bi bi-check-square-fill"></i> Enregistrer & Continuer l'achat
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row px-2">
      <div :class="errors != [] ? 'rounded bg-white border' : ''">
        <div v-for="(error, index) in errors" :key="index" class="col-12">
          <div class="text-danger py-1">
            {{ index + " - " + error }}
          </div>
        </div>
      </div>
    </div>
    <br />

    <!-- ===== Invoice Parse Modal ===== -->
    <div id="modal" v-if="showInvoiceModal" class="rounded">
      <div class="p-3" style="width:900px;max-width:95vw">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">
            <i class="bi bi-file-earmark-text me-2"></i>
            Facture importée — vérifiez et confirmez
          </h5>
          <button class="btn btn-sm btn-outline-secondary" @click="showInvoiceModal = false">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <!-- Header info from invoice -->
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="form-label fw-semibold">Fournisseur</label>
            <input type="text" class="form-control" v-model="parsedInvoice.supplier_name" />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Nº Facture</label>
            <input type="text" class="form-control" v-model="parsedInvoice.invoice_number" />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Date</label>
            <input type="date" class="form-control" v-model="parsedInvoice.date" />
          </div>
        </div>

        <!-- Items table -->
        <div class="table-responsive mb-3">
          <table class="table table-bordered table-sm">
            <thead class="table-light">
              <tr>
                <th>Désignation</th>
                <th style="width:90px">Quantité</th>
                <th style="width:110px">Prix TTC</th>
                <th style="width:110px">Prix HT</th>
                <th style="width:80px">TVA %</th>
                <th style="width:120px">Total TTC</th>
                <th style="width:40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in parsedInvoice.items" :key="i">
                <td>
                  <input type="text" class="form-control form-control-sm" v-model="row.designation" />
                </td>
                <td>
                  <input type="number" step="0.001" class="form-control form-control-sm" v-model="row.quantity" />
                </td>
                <td>
                  <input type="number" step="0.01" class="form-control form-control-sm" v-model="row.unit_price_ttc" />
                </td>
                <td>
                  <input type="number" step="0.01" class="form-control form-control-sm" v-model="row.unit_price_ht" />
                </td>
                <td>
                  <input type="number" step="0.5" class="form-control form-control-sm" v-model="row.tva_rate" />
                </td>
                <td>
                  <input type="number" step="0.01" class="form-control form-control-sm" v-model="row.total_ttc" />
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm text-danger p-0" @click="parsedInvoice.items.splice(i, 1)">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-warning fw-bold">
                <td colspan="5" class="text-end">Total TTC :</td>
                <td>{{ parsedInvoice.total_ttc | toFixedWithSpace }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- New items notice -->
        <div v-if="unmatchedItems.length > 0" class="alert alert-info py-2 small">
          <i class="bi bi-plus-circle me-1"></i>
          <strong>{{ unmatchedItems.length }} nouvel(s) article(s) seront créés automatiquement :</strong>
          {{ unmatchedItems.join(', ') }}
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <div class="text-muted small">
            Les articles inexistants dans le catalogue seront créés automatiquement.
          </div>
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-secondary" @click="showInvoiceModal = false">
              Annuler
            </button>
            <button type="button" class="btn btn-primary" @click="applyParsedInvoice">
              <i class="bi bi-check2-all me-1"></i>
              Importer {{ parsedInvoice.items.length }} ligne(s)
            </button>
          </div>
        </div>
      </div>
    </div>

    <h5 class="mb-3">Articles de l'achat</h5>

    <!-- Invoice upload button -->
    <div class="mb-3">
      <input
        type="file"
        ref="invoiceFileInput"
        accept="image/*,.pdf,.xlsx,.xls,.csv,.docx,.doc"
        class="d-none"
        @change="onInvoiceFileSelected"
      />
      <button
        type="button"
        class="btn btn-outline-primary"
        :disabled="invoiceParsing"
        @click="$refs.invoiceFileInput.click()"
      >
        <span v-if="invoiceParsing">
          <span class="spinner-border spinner-border-sm me-1"></span>
          Analyse en cours…
        </span>
        <span v-else>
          <i class="bi bi-upload me-1"></i>
          Importer facture fournisseur
        </span>
      </button>
      <span class="text-muted ms-2 small">Image, PDF, Excel, CSV, Word — les articles seront auto-remplis</span>
    </div>

    <form @submit.prevent="saveLineItem()">
      <div class="row align-items-end">
        <div class="col-xl-4 col-12 my-3">
          <label for="itemInput">Article</label>
          <vue-select
            :options="filteredItems"
            v-model="purchase_item.item_reference"
            placeholder="Sélectionner un article"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div v-if="isMultipleStock" class="col-xl-3 col-12 my-3">
          <label for="">
            Stock <span class="text-danger">*</span>
          </label>
          <select
            v-model="purchase_item.stock_reference"
            class="form-select"
            :class="{
              'is-invalid':
                isMultipleStock &&
                needsStockSelection &&
                !purchase_item.stock_reference,
            }"
          >
            <option value="">Sélectionner un stock</option>
            <option
              v-for="(stock, index) in filteredStockItems"
              :key="index"
              :value="stock.reference"
            >
              {{ stock.stockFullName || stock.fullName || stock.reference }} —
              Qté : {{ parseFloat(stock.quantity || 0).toFixed(2) }}
              {{ stock.measuring || "" }}
            </option>
          </select>
          <div
            v-if="
              isMultipleStock &&
              needsStockSelection &&
              !purchase_item.stock_reference
            "
            class="invalid-feedback d-block"
          >
            Veuillez sélectionner un stock
          </div>
        </div>

        <div class="col-xl-2 col-12 my-3">
          <label for="">Prix achat TTC</label>
          <input
            type="text"
            v-model="purchase_item.priceTTC"
            @input="calculatePriceHT"
            class="form-control"
          />
        </div>

        <div class="col-xl-2 col-12 my-3">
          <label for="">Prix vente TTC</label>
          <input
            type="text"
            v-model="purchase_item.salePriceTTC"
            class="form-control"
          />
        </div>

        <div class="col-xl-2 col-12 my-3">
          <label for="quantity"> Quantité </label>
          <input
            name="quantity"
            type="text"
            v-model="purchase_item.quantity"
            @input="calculateTotalPrice"
            class="form-control"
          />
        </div>

        <div class="col-xl-2 col-12 my-3">
          <label for="">Quantité (Unites)</label>
          <input
            type="text"
            v-model="purchase_item.pcs"
            class="form-control"
          />
        </div>

        <div class="col-xl-2 col-12 my-3">
          <label for="">Total TTC</label>
          <input
            type="text"
            :value="
              (purchase_item.priceTTC * purchase_item.quantity) | toFixedWithSpace
            "
            class="form-control"
            disabled
          />
        </div>

        <div class="col-xl-2 col-12 my-3">
          <label for="">Remarque </label>
          <input
            type="text"
            v-model="purchase_item.remark"
            class="form-control"
          />
        </div>

        <div class="col-auto my-3">
          <label for=""></label>
          <button class="btn btn-success" type="submit">
            <i class="bi bi-plus-circle"></i> Insérer
          </button>
        </div>

        <div class="col-auto my-3">
          <label for=""> </label>
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center"
            @click="refreshItems()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Actualiser </span>
          </button>
        </div>

        <div class="col-auto my-3">
          <label for=""></label>
          <button class="btn btn-primary" type="button" @click="showModal = true">
            <i class="bi bi-plus-circle"></i> Créer article
          </button>
        </div>
      </div>
    </form>

    <hr />
    <br />

    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Prix achat TTC</th>
          <th scope="col">Prix vente TTC</th>
          <th scope="col">Prix HT</th>
          <th scope="col">Quantité</th>
          <th scope="col">Montant Total</th>
          <th scope="col">Stock</th>
          <th scope="col">Créé par</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in purchase_items" :key="row.id || index">
          <td>{{ index + 1 }}</td>

          <td>
            <span v-if="row.item">
              {{ row.item.fullName }}
            </span>
          </td>
          <td class="">
            <span v-if="row.priceTTC != null">
              {{ row.priceTTC | toFixedWithSpace }}
            </span>
          </td>

          <td class="">
            <span v-if="row.item && row.item.priceTTC != null">
              {{ row.item.priceTTC | toFixedWithSpace }}
            </span>
          </td>

          <td class="">
            <span v-if="row.priceHT != null">
              {{ row.priceHT | toFixedWithSpace }}
            </span>
          </td>
          <td class="">
            <span v-if="row.quantity != null">
              {{ row.quantity }}
            </span>
          </td>
          <td class="">
            <span v-if="row.totalPriceTTC != null">
              {{ row.totalPriceTTC | toFixedWithSpace }}
            </span>
          </td>
          <td>
            {{ stockLineLabel(row) }}
          </td>
          <td>
            <span v-if="row.user">
              {{ row.user.name }}
            </span>
          </td>
          <td class="d-flex">
            <button type="button" @click="remove(row)" class="btn text-danger">
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-0">
          <td></td>

          <td>Total :</td>
          <td class=""></td>
          <td class=""></td>

          <td>
            <span
              v-if="totalPriceHTItems != null"
              class="fw-bold bg-warning px-2 py-1 rounded"
            >
              {{ totalPriceHTItems | toFixedWithSpace }}
            </span>
          </td>

          <td>
            <span
              v-if="totalQuantityItems != null"
              class="fw-bold bg-warning px-2 py-1 rounded"
            >
              {{ totalQuantityItems }}
            </span>
          </td>

          <td>
            <span
              v-if="totalPriceTTCItems != null"
              class="fw-bold bg-warning px-2 py-1 rounded"
            >
              {{ totalPriceTTCItems | toFixedWithSpace }}
            </span>
          </td>

          <td>
            TVA :
            <span
              v-if="totalPriceTTCItems != null && totalPriceHTItems != null"
              class="fw-bold bg-warning px-2 py-1 rounded"
            >
              {{ (totalPriceTTCItems - totalPriceHTItems) | toFixedWithSpace }}
            </span>
          </td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <br />

    <hr />
    <h5 class="mb-3">En-tête de l'achat</h5>

    <div class="row align-items-end">
      <div class="col-xl-3 col-md-4 my-3">
        <label for="">Fournisseur <span class="text-danger">*</span> </label>
        <vue-select
          :options="suppliers"
          v-model="supplier_reference"
          placeholder="Select an option"
          labelColumn="society"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-md-4 my-3">
        <label for="">Fournisseur <span class="text-danger">*</span> </label>
        <input
          type="text"
          :value="selectedSupplier.society"
          class="form-control"
          disabled
        />
      </div>

      <div class="col-auto my-3">
        <label for=""> </label>
        <button
          @click="$router.push({ name: 'suppliers-create' })"
          class="btn btn-secondary"
        >
          <i class="bi bi-plus-square"></i>
          Créer un fournisseur
        </button>
      </div>

      <div class="col-xl-3 col-md-4 my-3">
        <label for="">Date <span class="text-danger">*</span></label>
        <input
          type="date"
          :disabled="$userRole != 'Admin' ? true : false"
          v-model="purchase.date"
          class="form-control"
        />
      </div>

      <div class="col-auto my-3">
        <label for=""> </label>
        <button @click="selectTodayDate" class="btn btn-secondary">
          Date d'aujourd'hui
        </button>
      </div>

      <div class="col-xl-3 col-md-4 my-3">
        <label for="">
          Bon de Commande Nº <span class="text-danger">*</span>
        </label>
        <input type="text" v-model="purchase.orderNumber" class="form-control" />
      </div>

      <div class="col-xl-3 col-md-4 my-3">
        <label for="">Bon Livraison Nº </label>
        <input
          type="text"
          v-model="purchase.deliveryOrderNumber"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-md-4 my-3">
        <label for="">Facture Nº <span class="text-danger">*</span></label>
        <input type="text" v-model="purchase.invoiceNumber" class="form-control" />
      </div>

      <div class="col-xl-3 col-md-4 my-3">
        <label for="">Montant Payé <span class="text-danger">*</span> </label>
        <input type="text" v-model="purchase.amountPaid" class="form-control" />
      </div>

      <div class="col-xl-3 col-md-4 my-3" v-if="purchase.amountPaid > 0">
        <label for="">Mode de paiement <span class="text-danger">*</span></label>
        <select v-model="purchase.paymentMethod" class="form-select">
          <option value="Chèque">Chèque</option>
          <option value="Espèces">Espèces</option>
          <option value="Virement bancaire">Virement bancaire</option>
        </select>
      </div>

      <div
        class="col-xl-3 col-md-4 my-3"
        v-if="purchase.paymentMethod == 'Chèque'"
      >
        <label for="">Chèque Nº <span class="text-danger">*</span> </label>
        <input type="text" v-model="purchase.checkNumber" class="form-control" />
      </div>

      <div
        class="col-xl-3 col-md-4 my-3"
        v-if="purchase.paymentMethod == 'Virement bancaire'"
      >
        <label for="">Virement Nº <span class="text-danger">*</span> </label>
        <input
          type="text"
          v-model="purchase.transferNumber"
          class="form-control"
        />
      </div>

      <div class="col my-3">
        <label for=""> Remarque <span class="text-danger">*</span> </label>
        <input type="text" v-model="purchase.remark" class="form-control" />
      </div>
    </div>
    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-8"></div>
      <div class="col-auto">
        <button class="btn btn-success" type="button" @click="savePurchase(purchase)">
          <i class="bi bi-check-square-fill"></i> Enregistrer l'achat
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      item: {
        priceTTC: 0,
      },
      purchase_item: {
        item_reference: null,
        stock_reference: "",
        priceTTC: 0,
        salePriceTTC: "",
        priceHT: 0,
        totalPriceHT: 0,
        totalPriceTTC: 0,
        quantity: 1,
        pcs: "",
        remark: "",
      },
      section_reference: null,
      accept: false,
      showModal: false,
      showInvoiceModal: false,
      invoiceParsing: false,
      parsedInvoice: {
        supplier_name: "",
        invoice_number: "",
        date: "",
        items: [],
        total_ht: 0,
        total_tva: 0,
        total_ttc: 0,
      },
      purchase: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        amountPaid: 0.0,
      },
      selectedSupplier: {},
      supplier_reference: "",
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("section", {
      sections: "getAll",
    }),
    ...mapGetters("purchase", {
      purchase_items: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      totalPriceHTItems: "totalPriceHTItems",
      numberItems: "numberItems",
      errors: "getErrors",
    }),
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
    ...mapGetters("stock", {
      stockItems: "getStockItems",
    }),

    filteredStockItems() {
      if (!this.purchase_item.item_reference || !this.stockItems) {
        return [];
      }
      return this.stockItems.filter(
        (stockItem) =>
          stockItem.item_reference === this.purchase_item.item_reference
      );
    },

    needsStockSelection() {
      return this.filteredStockItems && this.filteredStockItems.length > 1;
    },

    filteredItems() {
      if (this.section_reference == null) {
        return this.items;
      }
      return this.items.filter(
        (item) => item.section_reference === this.section_reference
      );
    },

    selectedItemForLine() {
      if (!this.purchase_item.item_reference || !this.items) {
        return null;
      }
      return this.items.find(
        (p) => p.reference === this.purchase_item.item_reference
      );
    },

    isMultipleStock() {
      if (this.$settings && this.$settings.stock) {
        return this.$settings.stock === "multiple";
      }
      if (this.$setting && typeof this.$setting === "function") {
        return this.$setting("stock") === "multiple";
      }
      return false;
    },

    // Parsed invoice items that have a matching catalogue item (by name similarity)
    matchedParsedItems() {
      if (!this.parsedInvoice.items || !this.items) return [];
      return this.parsedInvoice.items.filter((row) =>
        this.findCatalogueItem(row.designation)
      );
    },

    unmatchedItems() {
      if (!this.parsedInvoice.items || !this.items) return [];
      return this.parsedInvoice.items
        .filter((row) => !this.findCatalogueItem(row.designation))
        .map((row) => row.designation);
    },
  },
  watch: {
    "purchase_item.item_reference"() {
      this.purchase_item.stock_reference = "";
      this.purchase_item.priceHT = 0;
      this.purchase_item.priceTTC = 0;
      this.purchase_item.salePriceTTC =
        this.selectedItemForLine && this.selectedItemForLine.priceTTC != null
          ? this.selectedItemForLine.priceTTC
          : "";
      this.purchase_item.quantity = 1;
      this.purchase_item.pcs = "";
      this.syncPurchasePcsFromQuantity();
      this.calculatePriceHT();
      this.calculateTotalPrice();
      if (
        this.isMultipleStock &&
        this.filteredStockItems &&
        this.filteredStockItems.length === 1
      ) {
        this.purchase_item.stock_reference = this.filteredStockItems[0].reference;
      }
    },
    supplier_reference(val) {
      if (!val) {
        this.selectedSupplier = {};
        this.purchase.supplier_reference = null;
        return;
      }
      this.selectedSupplier =
        this.suppliers.find((p) => p.reference === val) || {};
      this.purchase.supplier_reference = val;
    },
    "purchase_item.pcs": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.syncPurchaseQuantityFromPcs();
      }
    },
    "purchase_item.quantity": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.syncPurchasePcsFromQuantity();
        this.calculateTotalPrice();
      }
    },
  },
  methods: {
    stockLineLabel(row) {
      if (row.stock && row.stock.fullName) {
        return `${row.stock.fullName} / ${row.stock.reference}`;
      }
      const ref = row.stock_reference;
      if (!ref) return "—";
      const si = (this.stockItems || []).find((s) => s.reference === ref);
      if (si) {
        const name = si.stockFullName || si.fullName || "";
        return name ? `${name} (${ref})` : ref;
      }
      return ref;
    },

    async saveLineItem() {
      const itemRef = this.purchase_item.item_reference;
      if (!itemRef) {
        this.$store.dispatch(
          "notification/store",
          {
            status: "error",
            message: "Veuillez sélectionner un article.",
          },
          { root: true }
        );
        return;
      }

      const payload = { ...this.purchase_item, item_reference: itemRef };
      delete payload.pcs;

      if (this.isMultipleStock) {
        const list = this.filteredStockItems || [];
        if (list.length > 1 && !payload.stock_reference) {
          this.$store.dispatch(
            "notification/store",
            {
              status: "error",
              message: "Veuillez sélectionner un stock pour cet article.",
            },
            { root: true }
          );
          return;
        }
        if (list.length === 1) {
          payload.stock_reference = list[0].reference;
        }
      } else {
        payload.stock_reference = payload.stock_reference || "";
      }

      try {
        await this.$store.dispatch("purchase/storeItem", payload);
        this.resetPurchaseItemForm();
        await this.$store.dispatch("item/getAll");
        await this.$store.dispatch("stock/fetchStocksItems");
      } catch (error) {
        /* store shows errors */
      }
    },

    resetPurchaseItemForm() {
      this.purchase_item = {
        item_reference: null,
        stock_reference: "",
        priceTTC: 0,
        salePriceTTC: "",
        priceHT: 0,
        totalPriceHT: 0,
        totalPriceTTC: 0,
        quantity: 1,
        pcs: "",
        remark: "",
      };
    },

    async saveNewCatalogItem(data) {
      try {
        const formData = new FormData();
        formData.append("fullName", data.fullName);
        if (data.description) formData.append("description", data.description);
        if (data.tva) formData.append("tva", data.tva);
        if (data.code) formData.append("code", data.code);
        if (data.priceTTC) formData.append("priceTTC", data.priceTTC);
        if (data.measuring) formData.append("measuring", data.measuring);
        formData.append("section_reference", data.section_reference);

        await this.$store.dispatch("item/storeAndRouteToPurchase", formData);
        await this.$store.dispatch("item/getAll");

        this.item = { priceTTC: 0 };
        if (this.$route.query.item_reference) {
          this.purchase_item.item_reference = this.$route.query.item_reference;
        }
        this.showModal = false;
      } catch (error) {
        /* handled in store */
      }
    },

    async remove(row) {
      await this.$store.dispatch("purchase/deleteItem", row.id);
      await this.$store.dispatch("purchase/getAllItems");
    },

    async refreshItems() {
      await this.$store.dispatch("stock/fetchStocksItems");
      await this.$store.dispatch("section/getAll");
      await this.$store.dispatch("item/getAll");
      await this.$store.dispatch("purchase/getAllItems");
      await this.$store.dispatch("stock/getAll");
    },

    async savePurchase(data) {
      if (!this.numberItems || this.numberItems < 1) {
        this.$store.dispatch(
          "notification/store",
          {
            status: "error",
            message: "Ajoutez au moins une ligne d'article avant d'enregistrer.",
          },
          { root: true }
        );
        return;
      }
      if (!data.supplier_reference) {
        this.$store.dispatch(
          "notification/store",
          {
            status: "error",
            message: "Veuillez sélectionner un fournisseur.",
          },
          { root: true }
        );
        return;
      }

      await this.$store.dispatch("purchase/store", data);

      setTimeout(() => {
        this.purchase = {
          date: new Date(new Date().setFullYear(new Date().getFullYear()))
            .toLocaleString("en-CA")
            .split(",")[0],
          amountPaid: 0.0,
        };
        this.accept = false;
        this.supplier_reference = "";
        this.selectedSupplier = {};
      }, 2000);
    },

    async selectTodayDate() {
      this.purchase.date = new Date(new Date().setFullYear(new Date().getFullYear()))
        .toLocaleString("en-CA")
        .split(",")[0];
    },

    // Find the best catalogue match for a designation string
    findCatalogueItem(designation) {
      if (!designation || !this.items) return null;
      const needle = designation.toLowerCase().trim();
      // Exact match first
      let found = this.items.find(
        (i) => i.fullName && i.fullName.toLowerCase().trim() === needle
      );
      if (found) return found;
      // Partial match (invoice name contains catalogue name or vice versa)
      found = this.items.find(
        (i) =>
          i.fullName &&
          (needle.includes(i.fullName.toLowerCase().trim()) ||
            i.fullName.toLowerCase().trim().includes(needle))
      );
      return found || null;
    },

    async onInvoiceFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      // Reset input so same file can be re-selected
      this.$refs.invoiceFileInput.value = "";

      this.invoiceParsing = true;
      try {
        // Read file as base64 data URL on the client — avoids PHP temp-file permissions
        const dataUrl = await new Promise(function(resolve, reject) {
          var reader = new FileReader();
          reader.onload  = function(e) { resolve(e.target.result); };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const result = await this.$store.dispatch("purchase/parseInvoice", {
          image:     dataUrl,
          mime_type: file.type,
          file_name: file.name,
        });

        if (result && result.status === "success" && result.data) {
          const data = result.data;
          this.parsedInvoice = {
            supplier_name:  data.supplier_name  || "",
            invoice_number: data.invoice_number || "",
            date:           data.date           || "",
            items:          Array.isArray(data.items) ? data.items : [],
            total_ht:       parseFloat(data.total_ht  || 0),
            total_tva:      parseFloat(data.total_tva || 0),
            total_ttc:      parseFloat(data.total_ttc || 0),
          };

          // Pre-fill invoice number and date in the purchase header if empty
          if (this.parsedInvoice.invoice_number && !this.purchase.invoiceNumber) {
            this.purchase.invoiceNumber = this.parsedInvoice.invoice_number;
          }
          if (this.parsedInvoice.date && !this.purchase.date) {
            this.purchase.date = this.parsedInvoice.date;
          }

          // Try to pre-select supplier if not already chosen
          if (!this.supplier_reference && this.parsedInvoice.supplier_name) {
            const needle = this.parsedInvoice.supplier_name.toLowerCase().trim();
            const matchedSupplier = this.suppliers.find(
              (s) =>
                s.society &&
                (s.society.toLowerCase().trim() === needle ||
                  s.society.toLowerCase().trim().includes(needle) ||
                  needle.includes(s.society.toLowerCase().trim()))
            );
            if (matchedSupplier) {
              this.supplier_reference = matchedSupplier.reference;
            }
          }

          this.showInvoiceModal = true;
        }
      } catch (_) {
        // error already dispatched to notification store
      } finally {
        this.invoiceParsing = false;
      }
    },

    async applyParsedInvoice() {
      var items = this.parsedInvoice.items.filter(function(r) {
        return r.designation && r.designation.trim() !== "";
      });

      if (!items.length) {
        this.$store.dispatch(
          "notification/store",
          { status: "error", message: "Aucun article à importer." },
          { root: true }
        );
        return;
      }

      try {
        var result = await this.$store.dispatch("purchase/applyInvoiceItems", {
          items:          items,
          supplier_name:  this.parsedInvoice.supplier_name  || "",
          invoice_number: this.parsedInvoice.invoice_number || "",
          date:           this.parsedInvoice.date           || "",
        });

        // Refresh dropdowns so newly created items/suppliers appear
        await Promise.all([
          this.$store.dispatch("item/getAll"),
          this.$store.dispatch("stock/fetchStocksItems"),
          this.$store.dispatch("supplier/getAll"),
        ]);

        // Auto-select the supplier (found or newly created)
        if (result && result.supplier && result.supplier.reference) {
          this.supplier_reference = result.supplier.reference;
        }

        // Auto-select the first item in the item_reference dropdown
        // (shows the user what was imported and makes it ready for further editing)
        if (result && result.item_references && result.item_references.length > 0) {
          var firstItem = result.item_references[0];
          this.purchase_item.item_reference = firstItem.reference;
          this.purchase_item.priceTTC = firstItem.priceTTC || 0;
          this.calculatePriceHT();
        }

        // Pre-fill header fields if not already set
        if (this.parsedInvoice.invoice_number && !this.purchase.invoiceNumber) {
          this.purchase.invoiceNumber = this.parsedInvoice.invoice_number;
        }
        if (this.parsedInvoice.date && !this.purchase.date) {
          this.purchase.date = this.parsedInvoice.date;
        }

        this.showInvoiceModal = false;

        var newCount = result && result.item_references
          ? result.item_references.filter(function(i) { return i.is_new; }).length
          : 0;
        var msg = (result && result.message) ? result.message : items.length + " ligne(s) importée(s).";
        if (newCount > 0) {
          msg += " (" + newCount + " nouvel(s) article(s) créé(s) dans le catalogue)";
        }

        this.$store.dispatch(
          "notification/store",
          { status: "success", message: msg },
          { root: true }
        );
      } catch (_) {
        // error already dispatched by the store action
      }
    },

    calculatePriceHT() {
      const sel = this.selectedItemForLine;
      if (!sel || sel.tva == null) return;
      this.purchase_item.priceHT =
        Math.round(
          (this.purchase_item.priceTTC / (1 + sel.tva / 100)) * 100
        ) / 100;
      this.calculateTotalPrice();
    },

    selectedItemPcs() {
      const sel = this.selectedItemForLine;
      const pcs = sel ? parseFloat(sel.pcs) : 0;
      return pcs > 0 ? pcs : 0;
    },

    syncPurchaseQuantityFromPcs() {
      const itemPcs = this.selectedItemPcs();
      const pcs = parseFloat(this.purchase_item.pcs);

      if (!itemPcs || !pcs) {
        return;
      }

      const calculatedQuantity = (pcs / itemPcs).toFixed(2);
      if (this.purchase_item.quantity !== calculatedQuantity) {
        this.purchase_item.quantity = calculatedQuantity;
      }
      this.calculateTotalPrice();
    },

    syncPurchasePcsFromQuantity() {
      const itemPcs = this.selectedItemPcs();
      const quantity = parseFloat(this.purchase_item.quantity);

      if (!itemPcs || !quantity) {
        return;
      }

      const calculatedPcs = Math.round(quantity * itemPcs).toString();
      if (this.purchase_item.pcs !== calculatedPcs) {
        this.purchase_item.pcs = calculatedPcs;
      }
    },

    calculateTotalPrice() {
      this.purchase_item.totalPriceTTC = Math.round(
        this.purchase_item.priceTTC * this.purchase_item.quantity
      );
      this.purchase_item.totalPriceHT = Math.round(
        this.purchase_item.priceHT * this.purchase_item.quantity
      );
    },
  },
  filters: {
    date: function (date) {
      return moment(date).format("DD-MM-yyyy");
    },
    toFixedWithSpace: (value) => {
      if (value === null || value === undefined || value === "") return "";
      const n = parseFloat(value);
      if (isNaN(n)) return "";
      return n
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
  async beforeMount() {
    await this.$store.dispatch("stock/fetchStocksItems");
    await this.$store.dispatch("section/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("purchase/getAllItems");
    await this.$store.dispatch("supplier/getAll");
    await this.$store.dispatch("stock/getAll");

    if (this.$route.query.item_reference) {
      this.purchase_item.item_reference = this.$route.query.item_reference;
    }

    if (this.$route.query.supplier_reference) {
      this.supplier_reference = this.$route.query.supplier_reference;
      this.selectedSupplier =
        this.suppliers.find(
          (s) => s.reference === this.$route.query.supplier_reference
        ) || {};
      this.purchase.supplier_reference = this.supplier_reference;
    }
  },
};
</script>

<style scoped>
#modal {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

#modal > div {
  background-color: #fff;
  width: 750px;
  max-height: 90vh;
  overflow: auto;
  padding: 1rem !important;
}
</style>
